import { ChangeDetectorRef, Component, OnInit, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FinanceiroService } from '../../../../services/financeiro.service';
import { OrcamentoDTO, OrcamentoPaginado } from '../../../../models/financeiro.model';
import { ErrorModel } from '../../../../models/error.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxMaskPipe } from 'ngx-mask';
import { VendaModalV2 } from '../../../modal/venda-modal-v2/venda-modal-v2';
import { OrcamentoPdfComponent } from './orcamento-pdf.component';

@Component({
  selector: 'app-orcamentos',
  standalone: true,
  imports: [CommonModule, FormsModule, VendaModalV2, OrcamentoPdfComponent],
  templateUrl: './orcamentos.component.html',
  styleUrl: './orcamentos.component.css'
})
export class OrcamentosComponent implements OnInit {
  orcamentos: OrcamentoDTO[] = [];
  displayedOrcamentos: OrcamentoDTO[] = [];
  selectedOrcamento: OrcamentoDTO | null = null;

  isVendasModalOpen = false;
  currentPage = 0;
  readonly itemsPerPage = 10;
  totalPages = 1;
  totalElements = 0;

  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  searchTerm = '';

  @ViewChild(OrcamentoPdfComponent) private orcamentoPdfComponent?: OrcamentoPdfComponent;

  constructor(
    private financeiroService: FinanceiroService, 
    private router: Router,
    private toastr: ToastrService
  ) { }
  
  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.loadOrcamentos();
  } 

  loadOrcamentos(page: number = 0): void {
    this.financeiroService.getOrcamentosAbertos(page, this.itemsPerPage).subscribe({
      next: (data: OrcamentoPaginado) => {
        this.orcamentos = data.content;
        this.totalPages = data.totalPages;
        this.totalElements = data.totalElements;
        this.currentPage = page;
        this.displayedOrcamentos = [...this.orcamentos];
        this.updatePageNumbers();
        this.cdr.detectChanges();
      },
      error: () => {
        this.cdr.detectChanges();
      }
    });
  }

  search(): void {
    const termo = this.searchTerm.trim();
    if (!termo) {
      this.loadOrcamentos();
      return;
    }
    this.financeiroService.buscarOrcamentosAbertos(termo).subscribe({
      next: (data: OrcamentoDTO[]) => {
        this.displayedOrcamentos = data;
        this.totalPages = 1;
        this.totalElements = data.length;
        this.currentPage = 0;
        this.updatePageNumbers();
        this.cdr.detectChanges();
      },
      error: (err) => {
        const erro: ErrorModel = err.error ?? { message: 'Erro ao buscar orçamentos.' };
        this.toastr.error(erro.message ?? 'Erro ao buscar orçamentos.');
        this.cdr.detectChanges();
      }
    });
  }

  limparBusca(): void {
    this.searchTerm = '';
    this.loadOrcamentos();
  }

  setPage(page: number): void {
    if (page < 0 || page >= this.totalPages) return;
    this.loadOrcamentos(page);
  }

  updatePageNumbers(): void {
    const halfPages = Math.floor(this.maxPagesToShow / 2);
    this.startPage = Math.max(0, this.currentPage - halfPages);
    this.endPage = Math.min(this.totalPages - 1, this.startPage + this.maxPagesToShow - 1);

    if (this.endPage - this.startPage + 1 < this.maxPagesToShow) {
      this.startPage = Math.max(0, this.endPage - this.maxPagesToShow + 1);
    }

    this.pages = Array.from({ length: (this.endPage - this.startPage) + 1 }, (_, i) => this.startPage + i);
  }

  novoOrcamento(): void {
    this.router.navigate(['/home', 'venda-orcamento-item'], {
      queryParams: { origem: 'orcamentos' }
    });
  }

  editarOrcamento(id: number): void {
    this.router.navigate(['/home', 'venda-orcamento-item', id], {
      queryParams: { origem: 'orcamentos' }
    });
  }

  imprimirOrcamento(id: number): void {
    this.financeiroService.getEspelhoOrcamento(id).subscribe({
      next: (espelho) => {
        this.orcamentoPdfComponent?.printOrcamento(espelho);
      },
      error: (err) => {
        const erro: ErrorModel = err.error ?? { message: 'Erro ao gerar espelho do orçamento.' };
        this.toastr.error(erro.message ?? 'Erro ao gerar espelho do orçamento.');
      }
    });
  }

  deleteOrcamento(id: number): void {

  }

  converterEmVenda(orcamento: OrcamentoDTO): void {
    this.selectedOrcamento = orcamento;
    this.isVendasModalOpen = true;
  }

  closeModalVendas(concluido: boolean): void {
    this.isVendasModalOpen = false;
    this.selectedOrcamento = null;
    this.loadOrcamentos(concluido ? 0 : this.currentPage);
  }
}
